export default "__VITE_ASSET__gRzscFRb__"